module.exports = __webpack_public_path__ + "e82f48f5283da66ce4c244d3f97782c4.pdf";